<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card>
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <h2>Adiantamento</h2>
          <div>Informar valor de adiantamento do orçamento</div>
        </div>
      </div>

      <v-form @submit.prevent="handleSave">
        <v-card-text class="px-6 py-6">
          <v-text-field
            ref="entryValueInput"
            type="text"
            v-model="entryValue"
            label="Valor do adiantamento"
            outlined
            dense
            v-money="moneyConfig"
          ></v-text-field>

          <v-row align="center" class="text-center mt-4">
            <v-col cols="6">
              <div class="info-label">Total do orçamento</div>
              <div class="info-value">{{ total }}</div>
            </v-col>
            <v-col cols="6">
              <div class="info-label">Restante a pagar</div>
              <div
                class="info-value"
                :class="{
                  'text-success': remaining >= 0,
                  'text-error': remaining < 0,
                }"
              >
                {{ formatCurrency(remaining) }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>

      <v-footer class="save-button" absolute app>
        <v-btn
          block
          color="primary"
          @click="handleSave"
          class="mb-2"
          :loading="isLoading"
        >
          Salvar
        </v-btn>
      </v-footer>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import BudgetService from '@/services/api/budget';

export default {
  name: 'EntryValue',
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    total: {
      type: String,
      default: 'R$ 0,00',
    },
  },
  data() {
    return {
      entryValue: 'R$ 0,00',
      isLoading: false,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  computed: {
    ...mapState('Budget', ['selectedBudget']),
    remaining() {
      const totalValue = this.parseCurrency(this.total);
      const entryValueParsed = this.parseCurrency(this.entryValue);
      return totalValue - entryValueParsed;
    },
  },
  watch: {
    selectedBudget: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        const value = parseFloat(newValue.entry_value) || 0;
        this.entryValue = this.formatCurrency(value);
      },
    },
    isActive(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.initializeValue();
        }, 100);
      }
    },
  },
  methods: {
    initializeValue() {
      if (!this.selectedBudget) return;

      const value = parseFloat(this.selectedBudget.entry_value) || 0;
      this.entryValue = this.formatCurrency(value);

      setTimeout(() => {
        if (this.$refs.entryValueInput) {
          const inputEl =
            this.$refs.entryValueInput.$el.getElementsByTagName('input')[0];
          if (inputEl) {
            inputEl.value = this.entryValue;
            inputEl.dispatchEvent(new Event('input'));
          }
        }
      }, 50);
    },
    close() {
      this.initializeValue();
      this.$emit('close');
    },
    parseCurrency(value) {
      if (!value) return 0;
      return (
        parseFloat(
          value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim(),
        ) || 0
      );
    },
    formatCurrency(value) {
      if (Number.isNaN(value)) {
        return 'R$ 0,00';
      }

      return parseFloat(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    handleSave() {
      this.isLoading = true;

      const entryValueParsed = this.parseCurrency(this.entryValue);

      BudgetService.update(this.selectedBudget.id, {
        entry_value: entryValueParsed,
      })
        .then(() => {
          this.$store.commit('Budget/UPDATE_ENTRY_VALUE', entryValueParsed);

          this.$store.commit('Budget/ADD_LOG', {
            description: `Adiantamento alterado para ${this.formatCurrency(
              entryValueParsed,
            )}`,
            createdAt: new Date().toISOString(),
            user: this.$store.getters['Auth/user'],
          });

          this.$emit('save', entryValueParsed);
          this.$emit('close');
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.save-button {
  background-color: #ffffff !important;
  color: #fff;
}

.info-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.info-value {
  font-size: 16px;
  font-weight: 500;
}

.text-success {
  color: #48b38b;
}

.text-error {
  color: #e53e3e;
}

:deep(input) {
  text-align: center !important;
}

.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }
}
</style>
